import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

import { connect } from 'react-redux';
import { hideSnackbar } from '../../store/reducers/alerts/actions';

const StyledSnackbarContent = styled(SnackbarContent)({
  backgroundColor: '#4caf50'
});

const StyledErrorSnackbarContent = styled(SnackbarContent)({
  backgroundColor: '#af4c4c'
});

interface SnackBarMessageProps {
  text?: string | null;
  stack?: number;
  decreaseSnacStack?: ((payload: any) => void) | null;
  hasError?: boolean;
}

const SnackBarMessage = ({ text = null, stack = 0, decreaseSnacStack = null, hasError }: SnackBarMessageProps) => (
  <Snackbar
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    open={!!stack}
  >
    {!hasError ? (
      <StyledSnackbarContent
        message={text}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => decreaseSnacStack(0)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    ) : (
      <StyledErrorSnackbarContent
        message={text}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => decreaseSnacStack(0)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    )}
  </Snackbar>
);

const mapStateToProps = ({ alerts, prebooks }: any) => ({
  text: alerts.snackText,
  stack: alerts.snackStack,
  hasError: prebooks.hasError
});
const mapDispatchToProps = (dispatch: any) => ({
  decreaseSnacStack: (payload: any) => dispatch(hideSnackbar(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(SnackBarMessage);
